/**
 * True when this page is rendered inside the moderator preview iframe.
 *
 * The moderator Drafts tab (and the command palette) previews public pages by framing them
 * same-origin inside the PWA. A framed render must look exactly like the public page, must never
 * count as analytics (store_viewed, PostHog capture/replay), and must never show admin or chat
 * chrome. This is the single definition of "framed"; every such guard reads it.
 *
 * - SSR (no window): false.
 * - `self !== top`: framed.
 * - Reading `top` throws (cross-origin parent): treated as framed.
 */
export const isEmbeddedPreview = (
  win: { self: unknown; top: unknown } | undefined = typeof window !== "undefined" ? window : undefined,
): boolean => {
  if (!win) return false;
  try {
    return win.self !== win.top;
  } catch {
    return true;
  }
};
